import React from 'react';
import { withStyles } from 'material-ui/styles';
import UIDate from '../../core/ui/date.js';
import Hidden from 'material-ui/Hidden';

const styles = theme => ({
  date: {
    float: 'right',
  },
  author: {
  },
  intro: {
    fontSize: 10, 
    display: 'block',
    color: '#404040',
    marginBottom: 2,
    lineHeight: '15px',
    textAlign: 'justify',
  },
});


class Article extends React.Component {
  handleListItemClick(url) {
    if(!url) return;
    var win = window.open(url, '_blank');
    win.focus();

    const uri = '/google/q/this';
    const params = {q : '', url: url};
    this.props.server.get(uri, params, null);
    return false;
  }
  
  componentWillMount(){
    
  }
  
  render() {
const classes = this.props.classes;
    const article = this.props.data;
    const link = article.link;
    const body = 
      <div>
        <a className={'__link'} href={link}>
          <span className={'__type'}>
            <span>Article</span>
            {article.section &&
              <span>Section: [{article.section}]</span>
            }
            <span className={classes.date}><UIDate value={article.datepublished}/></span>
          </span>
        </a>      
        <a className={'__link'} href={link}>
          <span className={'__title'}>{article.title}</span>
        </a>
        <a className={'__link'} href={link}>          
          <span className={'__url'}>
            [{article.displayLink}]
          </span>
        </a>               
        {(article.author || article.publisher) &&
          <a className={'__link'} href={link}>
            <div className={'__type'}>
            {article.author &&
              <span className={classes.author}>by: {article.author} </span>
            }
            {article.publisher &&
              <span>publisher: {article.publisher}</span>
            }
            </div>
          </a>       
        }
        {article.intro &&
          <a className={'__link'} href={link}>
            <span className={'__snippet'}>{article.intro}</span>
          </a>
        }
        <a className={'__link'} href={link}>
          <span className={'__snippet'}>{article.body}</span>
        </a>
        {article.keywords &&
          <a className={'__link'} href={link}>
            <span className={'__type'}>keywords: {article.keywords}</span>
          </a>         
        }
      </div>;    

    return (
      article.img ?
        <table>
          <tbody>
            <tr>
              <td valign='top'>{body}</td>
            </tr>
          </tbody>
        </table>
      :
        body
    );    
  }

}

export default withStyles(styles)(Article);


// WEBPACK FOOTER //
// ./src/search/display/article.js